import { createStore, combineReducers } from 'redux';
import createSagaMiddleware from 'redux-saga';
import rootSaga from '../sagas';

const sagaMiddleware = createSagaMiddleware();

export default function configureStore({reducer, stateKey, applyMiddleware, sagas}) {
  if(stateKey){
    reducer = combineReducers({
      [stateKey]: reducer
    })
  }
  const store = createStore(
    reducer,
    {},
    applyMiddleware(sagaMiddleware)
  );

  sagaMiddleware.run(rootSaga(store.getState, sagas));
  return store;
}



// WEBPACK FOOTER //
// ./src/app/state/store/configureStore.prod.js